import { useCallback } from 'react';

const useYupValidationResolver = (validationSchema, updateState) =>
  useCallback(
    async (data, validationContext) => {
      try {
        updateState(true);
        const values = await validationSchema.validate(data, {
          abortEarly: false,
          context: validationContext,
        });
        return {
          values,
          errors: {},
        };
      } catch (errors) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors, currentError) => ({
              [currentError.path]: {
                type: currentError.type,
                message: currentError.message,
              },
              ...allErrors,
            }),
            {}
          ),
        };
      } finally {
        updateState(false);
      }
    },
    [validationSchema]
  );

export default useYupValidationResolver;
